import { Button, Container, Divider, Grid } from '@mui/material';
import { createColumnHelper } from '@tanstack/react-table';
import generateApiKey from 'generate-api-key';
import { cloneDeep } from 'lodash';
import { useEffect, useState } from 'react';

import { Permission } from '../../enums';
import useAppUtils from '../../utils/appUtils';
import clientUtils from '../../utils/clientUtils';
import FuelActionbar from '../fuel-actionbar';
import FuelTable from '../fuel-table/FuelTable';

interface IProps {
  formValue: any;
  permissions: Permissions;
}
const columnHelper = createColumnHelper<any>();
const initialPagination = {
  sortBy: 'name',
  descending: true,
  rowsPerPage: 100,
  page: 1,
  totalItems: 0,
  pages: 1,
};
const ApiKeys = ({ formValue, permissions }: IProps) => {
  const [items, setItems] = useState([]);
  const [pagination, setPagination] = useState(initialPagination);
  const { alert } = useAppUtils();
  const columns = [
    columnHelper.accessor('key', {
      align: 'left',
      header: () => 'Key',
      width: 150,
      sortable: false,
      footer: (props) => props.column.id,
      // cell: (cell) => <div title={cell.getValue()}>{cell.getValue()}</div>,
      cell: (cell) => {
        return (
          <div className="api-access-key-cell">
            <span className="api-access-key-data" title={cell.getValue()}>
              {cell.getValue()}
            </span>
            {cell.getValue() !== null && (
              <span className="copy-button icon">
                <i
                  aria-hidden="true"
                  className="fa fa-clone"
                  onClick={(event) => onTableAction(event, 'copy', cell.row.original, cell.table)}
                />
              </span>
            )}
          </div>
        );
      },
    }),
    columnHelper.accessor('actions', {
      header: 'Actions',
      footer: (props) => props.column.id,
      width: 50,
      sortable: false,
      cell: (cell) => (
        <FuelActionbar actions={cell.row.original.actions} item={cell.row.original} onActionButtonClick={onTableAction} />
      ),
    }),
  ];

  const addKey = () => {
    const key = generateApiKey();
    const keys = cloneDeep(formValue.getValues('apiKeyAccessRights'));
    keys[key] = {};
    formValue.setValue('apiKeyAccessRights', keys);
    constructJSONArray();
  };

  const deleteKey = (key: string) => {
    const keys = cloneDeep(formValue.getValues('apiKeyAccessRights'));
    if (key) {
      delete keys[key];
      formValue.setValue('apiKeyAccessRights', keys);
      constructJSONArray();
    }
  };
  const paginationChange = () => { };
  const onTableAction = (event, type, keyItem: any, context: any) => {
    if (type === 'delete') {
      deleteKey(keyItem.key);
    } else if (type === 'copy') {
      clientUtils.copyToClipboard(keyItem.key);
      alert('Api Key' + ' copied to clipboard!');
    }
  };

  const constructJSONArray = () => {
    // console.log('constructJSONArray');
    const apiKeyAccessRights = formValue.getValues('apiKeyAccessRights');
    // console.log('constructJSONArray', { apiKeyAccessRights });
    if (apiKeyAccessRights && Object.entries(apiKeyAccessRights).length > 0) {
      const actions = [
        {
          title: 'Remove',
          className: 'action',
          type: 'delete',
          iconClass: 'icon material-icons',
          iconName: 'delete',
          isDisabled: false,
        },
      ];
      const results = Object.keys(apiKeyAccessRights).map(function (k, i) {
        return {
          key: k,
          actions,
        };
      });

      setItems(results);
    } else {
      setItems([]);
    }
  };
  useEffect(() => {
    constructJSONArray();
  }, [formValue.getValues('apiKeyAccessRights')]);

  return (
    <Container className="no-padding" section="component" maxWidth="lg" sx={{ mt: '15px' }}>
      <Divider> Api Keys</Divider>

      <Grid container>
        <Grid item xs={12}>
          <div className="access-key-list">
            <FuelTable
              columnHelper={columnHelper}
              data={items}
              defaultColumns={columns}
              paginationDetail={pagination}
              paginationChange={paginationChange}
              showRowSelection={false}
              hidePagination
              loading={false}
              tableHeight={60}
              showActionbar
              customActionbarHtml={
                <div className="inline">
                  {permissions && permissions.has(Permission.ApiAccess) && (
                    <div className="inline custom-feed-buttons">
                      <Button variant="contained" size="small" className="browse-button" color="primary" onClick={() => addKey()}>
                        + Add Key
                      </Button>
                    </div>
                  )}
                </div>
              }
              hideActionbarButtons
              hideSearchControl
            />
          </div>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ApiKeys;
